/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyertoolpagedescription3Inputs */

const en_flyertoolpagedescription3 = /** @type {(inputs: Flyertoolpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a cover image, pick a format and place the QR code. Flyers can also be created directly on an event or place.`)
};

const de_flyertoolpagedescription3 = /** @type {(inputs: Flyertoolpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coverbild hochladen, Format wählen und QR-Code platzieren. Flyer können auch direkt bei einem Event oder Ort erstellt werden.`)
};

/**
* | output |
* | --- |
* | "Upload a cover image, pick a format and place the QR code. Flyers can also be created directly on an event or place." |
*
* @param {Flyertoolpagedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyertoolpagedescription3 = /** @type {((inputs?: Flyertoolpagedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyertoolpagedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyertoolpagedescription3(inputs)
	return de_flyertoolpagedescription3(inputs)
});
export { flyertoolpagedescription3 as "flyerToolPageDescription" }